import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=6f0a29ec&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=js&"
export * from "./forgot.vue?vue&type=script&lang=js&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=6f0a29ec&prod&lang=scss&"
import style1 from "./forgot.vue?vue&type=style&index=1&id=6f0a29ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a29ec",
  null
  
)

export default component.exports